import React, { useEffect, useState } from 'react';
const KTnetModal2 = props => {
  //console.log(props.sendCrtfctInfo())
  
  const [isInstall, setIsInstall] = useState(true);
  const popupWidth = 330;
  const popupHeight = 300;
  const popupX = (window.screen.width / 2) - (popupWidth / 2);
  const popupY= (window.screen.height /2) - (popupHeight / 2);

  // 리스너 호출
  useEffect(() => {
    window.addEventListener("message", messageFunc, false);
  }, []);

  // 리스너 호출해제
  // 해제안하면 윈도우에 계속 남아서 과부하 발생 
  useEffect(() => () => {
    window.removeEventListener("message", messageFunc, false);
  }, []);

  const messageFunc = (e) => {
    // e.origin ==  http://localhost:3000, e.data == {message: "closeScreen"}
    if (e.data.message){
      //console.log("11100000-0----", e.data.data)
      switch (e.data.message) {
        case 'installed':
          openToolkit();
          break;
        case 'closeScreen':
          props.onChange();  
          props.error({title: '확인', message: '공동인증서 인증을 실패하였습니다.'});
          break;
        // 인증됨
        case 'signComplete':
          // 인증처리 됬는지 return 확인
          props.onChange();
          //props.changeSignComplete();
          props.sendCrtfctInfo(e.data.data);
          //props.error({title: '확인', message: '사업자인증이 정상 인증되었습니다.'});          
          break; 
        case 'uninstalled':
          props.onChange();  
          setIsInstall(false);
          break;
        case 'popupDefaultClose':
          props.error({title: '확인', message: '팝업을 닫으면 정상적으로 인증되지 않습니다.\n 인증서 선택창을 취소하고 다시 공동인증서 인증버튼을 눌러 시도해 주시기 바랍니다.'});
          props.onChange();
          break;
        default:
          break;
      }
    }
  }

  useEffect(() => {
    if (props.isKTnetOpen) {
      openToolkit();
      setIsInstall(true);
    }
  }, [props.isKTnetOpen]);

  useEffect(() => {
    if (!isInstall) {
      window.open('/nxts/install/pki/index.htm', 'ktnetWindow2', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${window.screen.width}, height=${window.screen.height}`);
    }
  }, [isInstall]);

  
  const openToolkit = () => {
    window.open('/nxts/install/pki/openToolkit2.htm', 'ktnetWindow', `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=yes, resizable=no, copyhistory=no, width=${popupWidth}, height=${popupHeight}, left=${popupX}, top=${popupY}`);
  }

  return <div></div>;
}

export default KTnetModal2;